import { render, staticRenderFns } from "./TimezoneConverter.vue?vue&type=template&id=513ced28&scoped=true"
import script from "./TimezoneConverter.vue?vue&type=script&lang=js"
export * from "./TimezoneConverter.vue?vue&type=script&lang=js"
import style0 from "./TimezoneConverter.vue?vue&type=style&index=0&id=513ced28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ced28",
  null
  
)

export default component.exports